import type { ColDef, ValueFormatterParams } from "ag-grid-community";
import dayjs from "dayjs";

import { formatCurrencyValue } from "./currency";

export const formatCurrency = ({ value }: ValueFormatterParams) =>
  typeof value === "number" ? formatCurrencyValue(value) : "";

export const formatDate = ({ value }: ValueFormatterParams) =>
  value instanceof Date ? value.toLocaleDateString() : "";

export const formatDateTime = ({ value }: ValueFormatterParams) =>
  value instanceof Date ? dayjs(value).format("MMM D, YYYY h:mm A") : "";

export const dateColumn = {
  minWidth: 120,
  maxWidth: 160,
  sortable: true,
  filter: "agDateColumnFilter",
  valueFormatter: formatDate,
} satisfies ColDef;

export const dateTimeColumn = {
  minWidth: 170,
  maxWidth: 220,
  sortable: true,
  filter: "agDateColumnFilter",
  valueFormatter: formatDateTime,
} satisfies ColDef;

export const accessionColumn = {
  minWidth: 120,
  maxWidth: 150,
  filter: "agNumberColumnFilter",
  cellClass: "tabular-nums",
} satisfies ColDef;

export const donorIdColumn = {
  width: 150,
  minWidth: 130,
  maxWidth: 220,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const unosIdColumn = {
  minWidth: 110,
  maxWidth: 150,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const alternateIdColumn = {
  minWidth: 110,
  maxWidth: 180,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const orgColumn = {
  minWidth: 150,
  flex: 1,
  filter: "agSetColumnFilter",
} satisfies ColDef;

export const priceColumn = {
  minWidth: 110,
  maxWidth: 160,
  sortable: true,
  filter: "agNumberColumnFilter",
  cellClass: "tabular-nums ag-right-aligned-cell",
  headerClass: "ag-right-aligned-header",
  valueFormatter: formatCurrency,
} satisfies ColDef;

export const nameColumn = {
  minWidth: 160,
  flex: 1,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const emailColumn = {
  minWidth: 220,
  flex: 1,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const descriptionColumn = {
  minWidth: 220,
  flex: 3,
  filter: "agTextColumnFilter",
} satisfies ColDef;

export const actionsColumn = {
  minWidth: 80,
  maxWidth: 100,
  sortable: false,
  filter: false,
  suppressHeaderMenuButton: true,
  cellStyle: { padding: 0 },
} satisfies ColDef;
